module.exports = __webpack_public_path__ + "img/icons B_23.49f86837.png";